export const isPublicSelector = store => !store.auth.currentUser;
